var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "59466bb921"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.5 112.5 L 262.5 112.5 L 262.5 262.5 L 112.5 262.5 Z M 112.5 112.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59466bb921)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#050a30",
    d: "M 245.191406 147.117188 C 245.191406 147.117188 145.042969 147.117188 127.777344 147.117188 C 122.710938 147.117188 118.210938 146.101562 118.210938 141.347656 L 245.191406 135.578125 L 245.191406 124.039062 C 245.191406 114.484375 237.4375 112.5 227.882812 112.5 L 124.160156 129.808594 C 114.917969 131.863281 112.5 135.777344 112.5 141.347656 L 112.5 245.191406 C 112.5 254.746094 120.253906 262.5 129.808594 262.5 L 245.191406 262.5 C 254.746094 262.5 262.5 254.746094 262.5 245.191406 L 262.5 164.421875 C 262.5 154.871094 254.746094 147.117188 245.191406 147.117188 Z M 239.421875 216.347656 C 233.054688 216.347656 227.882812 211.175781 227.882812 204.808594 C 227.882812 198.4375 233.054688 193.269531 239.421875 193.269531 C 245.792969 193.269531 250.960938 198.4375 250.960938 204.808594 C 250.960938 211.175781 245.792969 216.347656 239.421875 216.347656 Z M 239.421875 216.347656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1db29d10f5a7015e522ec0814fef8b6b.svg";
export { ForwardRef as ReactComponent };